/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    h3: "h3",
    ul: "ul",
    li: "li",
    pre: "pre",
    em: "em",
    a: "a",
    strong: "strong",
    ol: "ol",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The main Icon component is a wrapper for whatever icon you place within it. This means a ", _jsx(_components.code, {
        children: "span"
      }), " wrapping an inline ", _jsx(_components.code, {
        children: "SVG"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["You can use whatever you like inside this ", _jsx(_components.code, {
        children: "Icon"
      }), " component."]
    }), "\n", _jsx(_components.h3, {
      children: "Why use it?"
    }), "\n", _jsx(_components.p, {
      children: "You will get several advantages on using it, like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Responsiveness in terms of ", _jsx(_components.code, {
          children: "font-size"
        })]
      }), "\n", _jsx(_components.li, {
        children: "Coloring"
      }), "\n", _jsx(_components.li, {
        children: "Accessibility"
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Importing Icons"
    }), "\n", _jsx(_components.p, {
      children: "In case your environment doesn't support tree-shaking, import the icons explicitly."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "// Named ES import\nimport { bell } from '@dnb/eufemia/icons'\n\n// or named import with modifier\nimport { bell as Bell } from '@dnb/eufemia/icons'\n\n// Default and explicit ES import\nimport Bell from '@dnb/eufemia/icons/bell'\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Icon Sizes"
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.em, {
        children: ["Exists in the ", _jsx(_components.a, {
          href: "/icons",
          children: "Icon Library"
        })]
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "default"
        }), " ", _jsx(_components.code, {
          children: "1rem"
        }), " (16px)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "medium"
        }), " ", _jsx(_components.code, {
          children: "1.5rem"
        }), " (24px)"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Additional Sizes"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "small"
        }), " ", _jsx(_components.code, {
          children: "0.75rem"
        }), " (12px)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "large"
        }), " ", _jsx(_components.code, {
          children: "2rem"
        }), " (32px)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "custom-size"
        }), " will not be responsive. Width and Height is set as ", _jsx(_components.code, {
          children: "pixels"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Custom project Icons"
    }), "\n", _jsxs(_components.p, {
      children: ["For decorative or functional icons (not illustrations) use ", _jsx(_components.code, {
        children: "SVG"
      }), " as it gives the user responsiveness and better accessibility. But it gives you also more control, so you can change the color and size inherited by the parent HTML element."]
    }), "\n", _jsx(_components.p, {
      children: "To optimize your SVG icons to be used with Eufemia, you can follow these steps or get at least, inspired:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Make sure your SVG icon fits in the two sizes (default of ", _jsx(_components.code, {
          children: "16px"
        }), " and medium of ", _jsx(_components.code, {
          children: "24px"
        }), ") with the correct stroke thickness of ", _jsx(_components.code, {
          children: "1.5px"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Copy"
        }), " the SVG markup (in Figma, ", _jsx(_components.code, {
          children: "right click"
        }), " -> ", _jsx(_components.code, {
          children: "Copy as"
        }), " -> ", _jsx(_components.code, {
          children: "Copy as SVG"
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Declutter"
        }), " and remove ID attributes in the markup, so they don't appear twice in your web application DOM. In most cases, you don't need ", _jsx(_components.code, {
          children: "<defs ... />"
        }), " and the corresponding ids anyway."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Optimize"
        }), " the SVG. Use e.g. ", _jsx(_components.a, {
          href: "https://jakearchibald.github.io/svgomg/",
          children: "Online SVGOMG"
        }), " by using ", _jsx(_components.code, {
          children: "Paste markup"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "NB:"
        }), " Do not remove ", _jsx(_components.code, {
          children: "viewBox"
        }), "! The ", _jsx(_components.code, {
          children: "viewBox"
        }), " will together with some CSS ensure that the icon scales based on the root font-size."]
      }), "\n", _jsx(_components.li, {
        children: "Copy again the optimized markup and paste it into your JSX component (inline) og SVG file."
      }), "\n", _jsxs(_components.li, {
        children: ["Consume the custom icons with either dynamic imports (", _jsx(_components.code, {
          children: "import(...)"
        }), ") if you have many icons, or use static imports, like so:"]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      children: "If you have an SVG loader"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import ImportedSVGIcon from 'my-icons/custom_icon.svg'\n\nrender(<Icon icon={ImportedSVGIcon} />)\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Inline the SVG in your JSX"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "function CustomSVGIcon(props) {\n  return <svg {...props}>...</svg>\n}\n\nrender(<Button icon={CustomSVGIcon} />)\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "SVG import in Create React App"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { ReactComponent as CustomIcon } from './custom_icon.svg'\n\nrender(<Icon size=\"medium\">{CustomIcon}</Icon>)\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Primary Icon"
    }), "\n", _jsxs(_components.p, {
      children: ["There is also the ", _jsx(_components.a, {
        href: "/uilib/components/icon-primary",
        children: "IconPrimary"
      }), " component, which comes with all the ", _jsx(_components.a, {
        href: "/icons/primary",
        children: "Primary Icons"
      }), " included in the ", _jsx(_components.code, {
        children: "@dnb/eufemia"
      }), ". you don't have to import the primary icons."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
